import getPublicPayToken from '../../../../../common/edlio-api/pay/getPublicPayToken';
import { formatValueToLocale } from '../../shared/utilities';
import captureMessage from '../utils/captureMessage';

export default class PaymentForm {

	constructor(form) {

		// initialize form payment choices
		this.itemCart = [];
		// {
		//  id: '',
		//  title: '',
		//  cost: 0,
		//  quantity: 0,
		//  type: ''
		// }

		this.listenersEstablished = false;
		this.payConfigured = false;
		this.authorized = false;
		this.payTotal = 0;
		this._isPaymentRelatedElementsShown = false;

		this.data = {
			form : form,
			settings : form.settings,
			stripe : form.stripe,
			card: form.card,
			orderedPaymentElementIds : form.orderedPaymentElementIds,
			orderSummary : form.orderSummary,
			paymentForm : form.paymentForm
		}

		this.useEdlioPay = this.data.form.usePay || false;
	}

	submitPaymentForm = async () => {
		var self = this;
		const errorElement = document.getElementById('card-errors');

		const cardHolder = document.getElementById('cardholder_name');
		let cardHolderName = '';

		if (cardHolder) {
			cardHolderName = cardHolder.value;
			
			if (!cardHolderName.length) {
				document.getElementById("cardholder_name_container").classList.add("revise");
				return false;
			}
		}

		// uses Stripe
		if (!this.useEdlioPay) {
			const result = await self.data.stripe.createToken(this.data.card, {name: cardHolderName})

			if (result.error) {
				// Inform the customer that there was an error.
				errorElement.textContent = result.error.message;
				return false;
			} else {
				// Send the token to your server.
				return stripeTokenHandler(result.token);
			}

			function stripeTokenHandler(token) {
				// Insert the token ID into the form so it gets submitted to the server
				var hiddenInput = document.createElement('input');
				hiddenInput.setAttribute('type', 'hidden');
				hiddenInput.setAttribute('name', 'stripeToken');
				hiddenInput.setAttribute('id', 'stripeTokenResult');
				hiddenInput.setAttribute('value', token.id);
				document.getElementById('payment_form_container').appendChild(hiddenInput);
				return token.id
			}

		} else {
			const {
				payToken,
				payDescriptor,
				cardDetails,
				payFee
			} = self.data.form;

			if (!payToken || !payDescriptor) {
				return false;
			}

			return {
				payToken,
				payDescriptor,
				cardDetails,
				payFee
			}
		}
	}

	addPaymentBlockListeners = () => {
		const self = this;
		const invalidChars = ["-", "+", "e"];

		// OPEN
		let paymentElements = document.querySelectorAll("[payment-element]");
		// convert from NodeList to Array for IE11
		paymentElements = Array.prototype.slice.call(paymentElements);
		paymentElements.forEach((el) => {
			el.addEventListener("keydown", (e) => {
				if (invalidChars.includes(e.key)) {
					e.preventDefault();
				}
			});
			
			const domInput = document.getElementById(`${el.id}`);

			if (domInput.type == 'checkbox' && !domInput.checked) {
				domInput.value = "0";
			}

			el.addEventListener("change", () => {
				self.removeBoundsError(el);

				if (domInput.type == 'checkbox') {
					domInput.value = domInput.checked ? domInput.dataset.baseCost : ""
				}

				const item = {
					id: el.id,
					type: "open",
					quantity: 1,
					title: document.querySelector("label[for='" + el.id + "']").dataset.label,
					cost: parseFloat(el.value).toFixed(2)
				};
				self.updateCartOpen(item);
			});
			// OPEN - MIN/MAX VALIDATION
			el.addEventListener("blur", () => {
				if (el.value) {
					const validationPass = self.validateBounds(el);
					if (!validationPass) {
						// passing item with cost = 0 and title removes the item from order summary
						const item = {
							id: el.id,
							type: "open",
							title: document.querySelector("label[for='" + el.id + "']").dataset.label,
							cost: 0
						};
						self.updateCartOpen(item);
					}
				}
			});
			this.triggerEvent(el, 'input');
		});

		// MULTIPLE CHOICE
		let multiChoiceFormBlocks = document.querySelectorAll('.multi-choice-pay');
		// convert from NodeList to Array for IE11
		multiChoiceFormBlocks = Array.prototype.slice.call(multiChoiceFormBlocks);
		// GET obj -> key = blockID, value = checked radio value for block
		multiChoiceFormBlocks.forEach((block) => {
			const otherRadio = block.querySelector("input[otherradio]");
			const otherInput = block.querySelector("input[name=" + block.id + "_other]");

			block.addEventListener("change", () => {
				const blockId = block.id;
				let multiChoiceRadios = block.querySelectorAll("input[name=" + blockId + "]");
				// convert from NodeList to Array for IE11
				multiChoiceRadios = Array.prototype.slice.call(multiChoiceRadios);
				if (otherInput) {
					self.removeBoundsError(otherInput);
				}

				multiChoiceRadios.forEach((radio) => {
					if (radio.checked) {
						const item = {
							id: radio.id,
							choiceIndex: radio.dataset.choiceindex,
							type: "multi",
							parentId: radio.dataset.parentid,
							parentTitle: radio.attributes.blocklabel.value,
							title: radio.attributes.label.value.replace("*", ""),
							cost: parseFloat(radio.value).toFixed(2),
							quantity: 1
						};
						self.updateCartMultiChoice(item);
						if(radio === otherRadio && otherInput.value) {
							const item = createValidatedItem(otherInput, otherRadio);
							self.updateCartMultiChoice(item);
						}
					}
				});
			});

			// MULTIPLE CHOICE - OTHER MIN/MAX VALIDATION
			if (otherInput) {
				otherInput.addEventListener("keydown", (e) => {
					if (invalidChars.includes(e.key)) {
						e.preventDefault();
					}
				});

				otherInput.addEventListener("blur", () => {
					if (otherInput.value) {
						otherRadio.checked = true;
						let item = createValidatedItem(otherInput, otherRadio);
						self.updateCartMultiChoice(item);
					} else {
						otherRadio.checked = false;
						self.removeBoundsError(otherInput);
					}
				});
			}
		});

		// Returns a removal item on validation failure
		function createValidatedItem (otherInput, otherRadio) {
			const validationPass = self.validateBounds(otherInput);
			let item;

			if (validationPass) {
				item = {
					id: otherRadio.id,
					choiceIndex: otherRadio.dataset.choiceindex,
					type: "multi-other",
					parentId: otherRadio.dataset.parentid,
					parentTitle: otherRadio.attributes.blocklabel.value,
					title: otherRadio.attributes.label.value.replace("*", ""),
					cost: parseFloat(otherRadio.value).toFixed(2),
					quantity: 1
				};
			} else {
				// passing item with cost = 0 and parentId removes the item from order summary
				item = {
					id: otherRadio.id,
					type: "multi-other",
					parentId: otherRadio.dataset.parentid,
					parentTitle: otherRadio.attributes.blocklabel.value,
					cost: 0
				};
			}
			return item;
		}

		// ITEM
		let itemElements = document.querySelectorAll(".sale-item");
		// convert from NodeList to Array for IE11
		itemElements = Array.prototype.slice.call(itemElements);
		itemElements.forEach((el) => {
			el.addEventListener("change", (evt) => {

				// Get the 'item-info' element
				const infoEl = el.querySelector('.item-info');

				// Get the 'quantity' checkbox/input / value
				const quantityEl = el.querySelector('.item-quantity');

				// quantityEl is null when item sold out
				if (quantityEl) {
					let quantityVal;
					if (quantityEl.type === "checkbox") {
						quantityVal = quantityEl.checked ? 1 : 0;
					} else if (quantityEl.type === "number") {
						if (invalidChars.some(test => quantityEl.value.includes(test))) {
							quantityVal = 0;
							quantityEl.value = 0;
						} else {
							quantityVal = Math.floor(Number(quantityEl.value));
						}
					}

					// Check if quantity is < stock availability
					let stockValidationPass = true;
					const stockAvailable = parseInt(infoEl.getAttribute("data-item-stock"));
					// stockAvailable == -1 means unlimited stock
					if (stockAvailable > -1) {
						if (quantityVal > stockAvailable) {
							stockValidationPass = false;
							self.addStockError(el);
						} else {
							self.removeStockError(el);
						}
					}

					// Get the 'variation' select element / value
					const variationEl = el.querySelector('.item-variations');
					let variationVal = variationEl ? variationEl.value : "";

					if (variationEl) {
						if (quantityVal && variationVal == "") {
							self.addVariationError(variationEl);
						} else {
							self.removeVariationError(variationEl);
						}
					}

					const boundsValidationPass = self.validateBounds(quantityEl);
					let item = null;
					if (!quantityVal || !stockValidationPass || !boundsValidationPass || (variationEl && !variationVal)) {
						// REMOVE item
						item = {
							id: infoEl.id,
							type: "item",
							title: variationEl ? variationEl : infoEl.getAttribute("data-parent-title"),
							parentTitle: variationEl ? infoEl.getAttribute("data-parent-title") : variationVal,
							cost: 0,
							quantity: 1
						};
						self.updateCartItem(item);
						return;
					} else {
						// ADD item
						item = {
							id: infoEl.id,
							type: "item",
							title: variationEl ? variationVal : infoEl.getAttribute("data-parent-title"),
							parentTitle: variationEl ? infoEl.getAttribute("data-parent-title") : variationVal,
							cost: infoEl.getAttribute("data-item-cost"),
							quantity: quantityVal
						};
						self.updateCartItem(item);
					}
				}
			});
			this.triggerEvent(el, 'input');
		});

		// Add input.currency-input formatting listeners
		let currencyInputs = document.querySelectorAll('.currency-input');
		// convert from NodeList to Array for IE11
		currencyInputs = Array.prototype.slice.call(currencyInputs);
		currencyInputs.forEach((el) => {
			el.addEventListener("blur", (e) => {
				if (el.value) {
					setTimeout(() => {
						const input = e.target;
						if (!input.value) { input.value = 0; }
						input.value = parseFloat(input.value).toFixed(2);
					}, 0);
				}
			});
		});

		// Add input.quantity formatting listeners
		let quantityInputs = document.querySelectorAll('.item-quantity');
		// convert from NodeList to Array for IE11
		quantityInputs = Array.prototype.slice.call(quantityInputs);
		quantityInputs.forEach((el) => {
			el.addEventListener("keydown", (e) => {
				if (invalidChars.includes(e.key)) {
					e.preventDefault();
				}
			});

			el.addEventListener("blur", (e) => {
				const input = e.target;
				if (input.value) {
					if (invalidChars.some(test => input.value.includes(test))) {
						input.value = "";
					} else {
						input.value = Math.floor(input.value);
					}
				} else {
					// clears any pasted invalid characters
					input.value = "";
				}
			});
		});

		// Focus child input.currency-input when parent div.currency-input-container clicked
		let currInputContainers = document.querySelectorAll('.currency-input-container');
		// convert from NodeList to Array for IE11
		currInputContainers = Array.prototype.slice.call(currInputContainers);
		currInputContainers.forEach((el) => {
			const input = el.querySelector('.currency-input');
			el.addEventListener("click", (e) => {
				input.focus();
			});
		});
	}

	updateCart = (newTotal = true) => {
		const orderListEl = document.getElementById('order_list');
		orderListEl.innerHTML = "";
		let grandTotal = 0, transFee = 0, beforeFee = 0, transactionFee = 0;
		const passTransactionFee = this.data.settings.transferFee;

		// If the only thing in the cart is the fee
		if (this.itemCart.length === 1 && this.itemCart[0].type === 'fee') {
			this.itemCart = [];
		}
		
		// order the cart based on the this.data.orderedPaymentElementIds array
		this.itemCart.sort((a, b) => {
			if (a.type === 'fee' && b.type != 'fee') {
				return 1;
			} 
			if (a.type != 'fee' && b.type === 'fee') {
				return -1;
			}
			return this.data.orderedPaymentElementIds.indexOf(a.id) < this.data.orderedPaymentElementIds.indexOf(b.id) ? -1 : 1;
		});

		if (this.useEdlioPay) {
			const cartWithoutFee = this.itemCart.filter(item => item.id !== 'processing_fee')
			const totalCartSumWithoutFee = cartWithoutFee.reduce((prev, curr) => prev + Number(curr.cost), 0)
			const hasValidationErrors = document.querySelector('.bounds-validation-error, .variation-validation-error, .stock-validation-error');

			if (this.itemCart.length === 0 || totalCartSumWithoutFee === 0) {
				if (!hasValidationErrors) {
					this._removeFeeFromCart();
					this._hidePaymentRelatedElementsAndEnableDefaultSubmit();
				}
			} else {
				if (!this._isPaymentRelatedElementsShown) {
					this._showPaymentRelatedElementsAndHideDefaultSubmit();
				}
			}
		}

		this.itemCart.forEach((item) => {
			if (item.type === 'fee') {
				transactionFee = item.cost;
			}

			let title = "";
			if (item.title && item.parentTitle && item.title != item.parentTitle) {
				title = item.parentTitle + " - " + item.title;
			} else if (item.title && !item.parentTitle) {
				title = item.title;
			} else if (item.parentTitle && !item.title) {
				title = item.parentTitle;
			} else if (item.parentTitle === item.title) {
				title = item.title
			}

			let itemCost = parseFloat(item.cost).toFixed(2) * item.quantity;

			let updatedTitle = item.quantity > 1 ? title + " x " + item.quantity : title;

			orderListEl.innerHTML += `<div class='payment-info-row'>
				<div>${updatedTitle}</div>
				<div class='currency-container'>
				<span class='currency-symbol'>$</span> <div class='currency-value'>${formatValueToLocale(itemCost)}</div>
				</div>`;

			grandTotal += itemCost;
		})

		beforeFee = grandTotal;
		this.subTotal = beforeFee;

		if (passTransactionFee) {
			// Add transFee
			grandTotal = this.addTransFee("Stripe", grandTotal);
			transFee = grandTotal - beforeFee;
		} else {
			transFee = 0;
		}

		// toggle payment-info-container / payform
		if (grandTotal > 0) {
			this.data.orderSummary.classList.remove('hide');
			this.showPaymentForm();
			if (this.useEdlioPay) {
				if (!this.payConfigured && !this.listenersEstablished) {
					this.edlioPayListeners();
				} else {
					const payAmount = grandTotal - transactionFee;
					if (newTotal && this.payConfigured) {
						EdlioPay.initialize({
							amount: payAmount
						}, true);
					}

					if (this.authorized) {
						this._hidePaymentRelatedElementsAndEnableDefaultSubmit();
					}
				}
			}
		} else if (this.itemCart.length) {
			this.data.orderSummary.classList.remove('hide');
			this.hidePaymentForm();
		} else {
			this.itemCart = [];
			this.data.orderSummary.classList.add('hide');
			this.hidePaymentForm();
		}

		this.displayTotal(beforeFee, transFee, grandTotal);
		// Set 'pay to stripe account' value
		this.payTotal = grandTotal;
	}

	_removeFeeFromCart = () => {
		this.itemCart = this.itemCart.filter(item => item.type !== 'fee');
	}

	_hidePaymentRelatedElementsAndEnableDefaultSubmit = () => {
		const widgetEl = document.getElementById("edliopay");

		widgetEl.style.display = "none";
		document.querySelector(".payment-disclosure").classList.add("hide");
		document.getElementById("submit_button").style.display = "block";
		document.getElementById("submit_button").classList.add("show");

		this.data.form.enableSubmit();

		this._isPaymentRelatedElementsShown = false;
	}

	_showPaymentRelatedElementsAndHideDefaultSubmit = () => {
		const widgetEl = document.getElementById("edliopay");

		widgetEl.style.display = "block";
		document.querySelector(".payment-disclosure").classList.remove("hide");
		document.getElementById("submit_button").style.display = "none";
		document.getElementById("submit_button").classList.remove("show");
		
		this._isPaymentRelatedElementsShown = true;
	}

	hidePaymentForm = () => {
		this.data.paymentForm.classList.add('hide');

		const widgetEl = document.getElementById("edliopay");
		if(widgetEl) {
			widgetEl.style.display = "none";
		}
		document.querySelector(".payment-disclosure").classList.add('hide');
	}

	showPaymentForm = () => {
		this.data.paymentForm.classList.remove('hide');

		const widgetEl = document.getElementById("edliopay");
		if(widgetEl) {
			widgetEl.style.display = "";
		}
		document.querySelector(".payment-disclosure").classList.remove('hide');
	}

	updateCartOpen = (item) => {
		let newItem = this.itemCart.every((cartItem) => {
			return cartItem.title !== item.title
		});

		let removeItem = false;
		if (item.cost == "" || !item.cost || isNaN(item.cost)) {
			removeItem = true;
		}

		if (!newItem) {
			for (let i = 0; i < this.itemCart.length; i++) {
				if (this.itemCart[i].title === item.title) {
					if (removeItem) {
						this.itemCart.splice(i, 1);
						this.updateCart();
					} else {
						this.itemCart[i].cost = item.cost;
						this.updateCart();
					}
					break;
				}
			}
		} else {
			if (!removeItem) {
				this.itemCart.push(item);
				this.updateCart();
			}
		}
	}

	updateCartMultiChoice = (item) => {
		let newParentId = this.itemCart.every((cartItem) => {
			return cartItem.parentId !== item.parentId;
		});

		// short circuit conditions
		const removeItem = (item.cost === "" || !item.cost || isNaN(item.cost) || item.title.includes("$placeholder"));
		if (removeItem) {
			for (let i = 0; i < this.itemCart.length; i++) {
				if (item.parentId === this.itemCart[i].parentId) {
					this.itemCart.splice(i, 1);
					this.updateCart();
					return;
				}
			}
			return;
		}

		if (!newParentId) {
			for (let i = 0; i < this.itemCart.length; i++) {
				if (item.parentId === this.itemCart[i].parentId) {
					this.itemCart.splice(i, 1);
				}
			}
		}
		// add item to cart
		this.itemCart.push(item);
		this.updateCart();
	}

	updateCartItem = (item) => {
		let newItemId = this.itemCart.every((cartItem) => {
			return cartItem.id !== item.id;
		});

		// short circuit conditions
		const removeItem = (item.cost === "" || !item.cost || isNaN(item.cost) || item.title.includes("$placeholder"));
		if (removeItem) {
			for (let i = 0; i < this.itemCart.length; i++) {
				if (item.id === this.itemCart[i].id) {
					this.itemCart.splice(i, 1);
					this.updateCart();
					return;
				}
			}
			return;
		}

		if (!newItemId) {
			for (let i = 0; i < this.itemCart.length; i++) {
				if (item.id === this.itemCart[i].id) {
					this.itemCart.splice(i, 1);
					break;
				}
			}
		}
		// add item to cart
		this.itemCart.push(item);
		this.updateCart();
	}

	updatePayFee = (feeValue) => {
		const item = {
			id: 'processing_fee',
			title : "Transaction Fee",
			cost: feeValue,
			quantity: 1,
			type: 'fee'
		}

		this.data.form.payFee = feeValue;

		// Reverse because the fee is always supposed to be last
		// if it is there, this will help us find it quicker
		const feeItemIndex = this.itemCart.reverse().findIndex((item) => item.type === 'fee');

		if (feeItemIndex === -1) {
			this.itemCart.push(item);
		} else {
			this.itemCart[feeItemIndex].cost = feeValue;
		}

		
		this.updateCart(false);
	}

	addTransFee = (merchantName, amount) => {
		if (!amount) {
			return 0;
		}
		let TRANS_FEE_PERCENTAGE, TRANS_FEE_FLAT, total;

		switch(merchantName) {
			case "Stripe":
				TRANS_FEE_PERCENTAGE = 2.9;
				TRANS_FEE_FLAT = 0.30;

				total = ((amount + TRANS_FEE_FLAT)/(1 - (TRANS_FEE_PERCENTAGE/100)));
				break;
			default:
				captureMessage(`Merchant: ${merchant} not supported.`);
				break;
		}
		return total;
	}

	checkPayMin = (merchantName, payTotal) => {
		let MIN_PAY;

		switch(merchantName) {
			case "Stripe":
				MIN_PAY = 1.00;
				break;
			default:
				captureMessage(`Merchant: ${merchant} not supported.`);
				break;
		}
		return payTotal >= MIN_PAY;
	}

	triggerEvent = (el, type) => {
		var e = document.createEvent('HTMLEvents');
		e.initEvent(type, false, true);
		el.dispatchEvent(e);
	}

	addVariationError (selectItem) {
		const id = selectItem.id
		const stripIndex = id.lastIndexOf("_");
		const errId = id.slice(0, stripIndex) + "_variation_error";
		const errorEl = document.getElementById(errId);
		errorEl.classList.add('error-flex');
		selectItem.classList.add("variation-validation-error");
		this.checkValidationErrors();
	}

	removeVariationError (selectItem) {
		const id = selectItem.id
		const stripIndex = id.lastIndexOf("_");
		const errId = id.slice(0, stripIndex) + "_variation_error";
		const errorEl = document.getElementById(errId);
		errorEl.classList.remove('error-flex');
		selectItem.classList.remove("variation-validation-error");
		this.checkValidationErrors();
	}

	addStockError (item) {
		const itemId = item.id;
		const stripIndex = itemId.lastIndexOf("_");
		const stockErrorId = itemId.slice(0, stripIndex) + "_stock_error";
		const stockErrorEl = document.getElementById(stockErrorId);
		stockErrorEl.classList.add("error-flex");

		const itemInput = item.querySelector("input");
		itemInput.classList.add("stock-validation-error");

		this.checkValidationErrors();
	}

	removeStockError (item) {
		const itemId = item.id
		const stripIndex = itemId.lastIndexOf("_");
		const stockErrorId = itemId.slice(0, stripIndex) + "_stock_error";
		const stockErrorEl = document.getElementById(stockErrorId);
		stockErrorEl.classList.remove('error-flex');

		const itemInput = item.querySelector("input");
		itemInput.classList.remove("stock-validation-error");

		this.checkValidationErrors();
	}

	validateBounds = (input) => {
		const value = Number(input.value);
		const min = Number(input.min);
		const max = input.max == "" ? false : Number(input.max);

		this.removeBoundsError(input);
		if ((max && value > max) || value < min) {
			// payment input fields are surrounded by container div
			this.addBoundsError(input);
			return false;
		} else {
			this.removeBoundsError(input);
			return true;
		}
	}

	addBoundsError = (inputItem) => {

		const id = inputItem.id
		const stripIndex = id.lastIndexOf("_");

		const maxValue = parseFloat(inputItem.max);

		const errId = id.slice(0, stripIndex) + "_bounds_error";
		const errorEl = document.getElementById(errId);
		const errorMessageContainer = errorEl.querySelector('.bounds-error-message');

		const quantityInput = id.includes("quantity");
		errorMessageContainer.innerText = quantityInput ? "Quantity" : "Amount";

		if (maxValue) {
			errorMessageContainer.innerText += " must be between " + (quantityInput ? inputItem.min : "$" + inputItem.min) + " - " + (quantityInput ? inputItem.max : "$" + inputItem.max);
		} else {
			errorMessageContainer.innerText += " must be at least " + (quantityInput ? inputItem.min : "$" + inputItem.min);
		}

		errorEl.classList.add('error-flex');

		if (inputItem.parentElement.classList.contains("currency-input-container")) {
			inputItem.parentElement.classList.add("bounds-validation-error");
		} else {
			inputItem.classList.add("bounds-validation-error");
		}
		this.checkValidationErrors();
	}

	removeBoundsError = (inputItem) => {
		const id = inputItem.id
		const stripIndex = id.lastIndexOf("_");
		const errId = id.slice(0, stripIndex) + "_bounds_error";
		const errorEl = document.getElementById(errId);
		const errorMessageContainer = errorEl.querySelector('.bounds-error-message');
		errorMessageContainer.innerText = "";
		errorEl.classList.remove('error-flex');

		if (inputItem.parentElement.classList.contains("currency-input-container")) {
			inputItem.parentElement.classList.remove("bounds-validation-error");
		} else {
			inputItem.classList.remove("bounds-validation-error");
		}
		this.checkValidationErrors();
	}

	checkValidationErrors = () => {
		const self = this;
		const submitErrorEl = document.querySelector('#submit_error');
		if (document.querySelector('.bounds-validation-error, .variation-validation-error, .stock-validation-error')) {
			submitErrorEl.classList.add('error-flex');
			self.data.form.disableSubmit();
		} else {
			submitErrorEl.classList.remove('error-flex');
			self.data.form.enableSubmit();
		}
	}

	displayTotal = (subtotal, transFee, total) => {
		const subTotalEl = document.getElementById('subtotal');
		const transFeeEl = document.getElementById('transaction_fee');
		const totalEl = document.getElementById('calculated_total');

		if (subTotalEl) { subTotalEl.innerText = subtotal.toFixed(2); }
		if (transFeeEl) { transFeeEl.innerText = transFee.toFixed(2); }
		if (totalEl) { totalEl.innerText = formatValueToLocale(total); }
	}

	async requestPayToken() {
		try {
			const formTitle = this.data.form.data.title;
			return getPublicPayToken(formTitle);
		} catch (err) {
			captureMessage('Failed to get public pay token');
			alert('Error encountered. Please refresh the page and try again.')
		}
	}

	async edlioPayListeners() {
		this.listenersEstablished = true;
		const payReq = await this.requestPayToken();

		const payToken = payReq.token;
		const descriptor = payReq.descriptor;
		
		if (!this.payConfigured) {
			/* This strips a trailing slash, which I thought we settled would be required
			* but here it's hurting so I'm removing it pending a discussion with OSP
			*/
			const payApiUrl = window.edlio.payApiUrl.replace(/\/$/, "");
			try {
				EdlioPay.configure({
					paymentApiUrl: payApiUrl,
					publicApiKey: window.edlio.payPublicKey,
					paymentToken: payToken,
					showInFrameResult: true,
					submitButtonLabel: this.data.form.settings.submitButtonLabel || 'Submit'
				});
			} catch(error) {
				console.log('Error configuring EdlioPay:', error);
				document.getElementById('loading_pay').innerText = 'Could not load payment form';
				return;
			}
		}

		EdlioPay.on("configured", (response) => {
			this.payConfigured = true;
			const payTotal = this._getPayTotal();

			EdlioPay.initialize({
				amount: payTotal
			});
		})

		EdlioPay.on("ready", (response) => {
			document.getElementById("loading_pay").style.display = "none";
			document.getElementById("payment_form_container").classList.remove("hide");
			document.querySelector(".payment-disclosure").classList.remove("hide");

			const submitButton = document.getElementById("submit_button");
			const payCardInfo = document.getElementById("pay_card_info").innerHTML;

			if (submitButton && !payCardInfo) {
				submitButton.style.display = "none";
				submitButton.classList.remove("show");
			}
		})

		EdlioPay.on("charge_ready", (event) => {
			const {
				card_expiration_year = '',
				card_expiration_month = '',
				card_number_masked,
				card_type
			} = event.data.payment.payment_card

			const cardDetails = {
				card_type : card_type.toLowerCase(),
				card_last_four : card_number_masked.slice(card_number_masked.length - 4),
				card_expiration_month,
				card_expiration_year
			}

			this.displayCardSVG(cardDetails)

			if (!this.authorized) {
				document.getElementById("processing_pay").classList.remove("hidden-init");
				document.getElementById("edliopay").style.display = "none";
				this.data.form.payToken = payToken;
				this.data.form.payDescriptor = descriptor;
				this.data.form.cardDetails = cardDetails;
				this.authorized = true;

				if(window.edlio.isFormsCaptchaActive && window.edlio.isPayFormsCaptchaActive && !window.grecaptcha.getResponse()) {
					window.grecaptcha.execute()

					if (!window.recaptchaCloseListener) {
						initRecaptchaListener();
					}

				} else {
					this.data.form._handleSubmit();
				}
			}
		})

		EdlioPay.on("api_error", (response) => {
			captureMessage(`EdlioPay returned "api_error"`);

			alert('Error encountered. Please refresh and try again.')

			return false;
		})

		EdlioPay.on("error", (response) => {
			captureMessage(`EdlioPay returned "error"`);

			alert('Error encountered. Please refresh and try again.')

			return false;
		})

		EdlioPay.on("card_error", (response) => {
			captureMessage(`EdlioPay returned "card_error"`);

			alert('Error encountered. Please refresh and try again.')

			return false;
		})

		EdlioPay.on("fee_calculated", (event) => {
			const payFee = event.data.calculated_fee;

			this.updatePayFee(payFee);
		})
	}

	reinitializeWidget = () => {
		const payTotal = this._getPayTotal();

		EdlioPay.initialize({
			amount: payTotal
		}, true);
	}

	resetDisplayCardSvg = () => {
		document.getElementById("pay_card_info").innerHTML = "";
	}

	displayCardSVG = (cardDetails) => {
		const container = document.getElementById("pay_card_info");

		let placeholder = "{{icon}}"
		let cardSvg = `<svg class="card icon">
							<use xlink:href="/apps/svg/icons.svg#${placeholder}"></use>
						</svg>`


		const updateSvg = (svgName) => {
			cardSvg = cardSvg.replace(placeholder, svgName)
		}

		switch (cardDetails.card_type) {
			case "visa" : updateSvg("visa-card");
				break;
			case "mastercard" : updateSvg("mastercard");
				break;
			case "discover" : updateSvg("discover-card");
				break;
			case "amex" : updateSvg("amex-card");
				break;
		}

		const innerHTML = `
			<span id="card_icon">${cardSvg}</span>
			<p id="centered_info">${cardDetails.card_type} ending in ${cardDetails.card_last_four}</p>
			<span id="expiration">Expires ${cardDetails.card_expiration_month}/${cardDetails.card_expiration_year}</span>
		`

		container.innerHTML = innerHTML;
	}

	updateItemInputs = (items) => {
		items.forEach((item) => {
			const itemType = item.type;
			if (itemType === 'fee') return;

			if (itemType === 'item') {
				if (document.getElementById(`${item.id}_quantity`)) {
					document.getElementById(`${item.id}_quantity`).value = item.quantity;
				} else if (document.getElementById(`${item.id}_checkbox`)) {
					document.getElementById(`${item.id}_checkbox`).checked = true;
				}
			} else if (itemType === 'multi') {
				document.getElementById(`${item.id}`).checked = true;
			} else if (itemType === 'open') {
				document.getElementById(`${item.id}`).value = item.cost;
			}
		})
	}

	_getPayTotal = () => {
		let payTotal = 0;

		if (this.itemCart.length) {
			this.itemCart.forEach((item) => {
				payTotal += +item.cost * item.quantity
			})

			let currentFee = this.itemCart.filter((item) => item.type === 'fee')[0];
			if (currentFee) {
				payTotal -= currentFee.cost;
			}
		}

		return payTotal
	}
}



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/public/classes/payment-form.js